import module from 'usuario/module.js'
import template from './template.html'

export class UsuarioVinculoDesvincularComponent {

  idUsuario = null
  desvinculando = false
  onClose = undefined
  constructor (EmpleadosEmpleadoVincular) {
   this.EmpleadosEmpleadoVincular = EmpleadosEmpleadoVincular
  }

  desvincular () {

    if (this.desvinculando) return

    this.desvinculando = true
    this.error = null

    this.EmpleadosEmpleadoVincular.delete(this.idUsuario)
      .then(() => (this.completado = true))
      .catch((response) => (this.error = response.data))
      .finally(() => (this.desvinculando = false))
  }

  cerrar () {
    this.onClose({$event: {detail: this.completado}})
  }

}

module.component('usuarioVinculoDesvincular', {
    controller: UsuarioVinculoDesvincularComponent,
    template,
    bindings: {
      idUsuario: '<',
      nombre: '<',
      onClose: '&',
    },
  })



// WEBPACK FOOTER //
// ./src/usuario/components/vinculo/desvincular/component.js